import { ProductLoadingStageEnum, ProductVisibilityENUM } from '../../enums/ProductEnums';

export class ProductState {
  //Dokumentacija loadingstage https://app.clickup.com/37442903/v/dc/13pnaq-732/13pnaq-1752
  private _loadingStage: ProductLoadingStageEnum;
  private _visibility: ProductVisibilityENUM;

  protected _isFlipped = false;

  public get isFlipped() {
    return this._isFlipped;
  }

  public set isFlipped(value: boolean) {
    this._isFlipped = value;
  }

  public get loadingStage() {
    return this._loadingStage;
  }

  public set loadingStage(loadingStage: ProductLoadingStageEnum) {
    this._loadingStage = loadingStage;
  }

  public get visibility() {
    return this._visibility;
  }

  public set visibility(visibility: ProductVisibilityENUM) {
    this._visibility = visibility;
  }

  constructor(
    loadingStage = ProductLoadingStageEnum.Loading,
    visibility = ProductVisibilityENUM.Visible,
    isFlipped = false,
  ) {
    this._loadingStage = loadingStage;
    this._visibility = visibility;
    this._isFlipped = isFlipped;
  }
}
